module.exports = __webpack_public_path__ + "img/follow-up-action-purple.cb430eef.svg";